import { ShiftManagementDefaultShiftsDocument } from 'generated/resources/graphql'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'

import DefaultShifts from 'modules/shift_management/store/internal/collections/DefaultShifts'

interface Props {
  fromUnassigned?: boolean
}

const useFetchDefaultShifts = ({ fromUnassigned = false }: Props) => {
  const { loading, data } = useQuery(ShiftManagementDefaultShiftsDocument, {
    variables: { unassignedShifts: fromUnassigned },
  })

  const defaultShifts: DefaultShifts = useUnsafeMemo(
    () => DefaultShifts.buildFromGraphQL(data?.shiftManagement?.defaultShifts || []),
    [data?.shiftManagement.defaultShifts]
  )

  return { defaultShifts, loading }
}

export default useFetchDefaultShifts
